
import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService, RoleApiService } from '@core/services';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalculator, faChartPie, faChartSimple, faGear, faHouse, faMoneyBillTransfer, faTable } from '@fortawesome/free-solid-svg-icons';
import { ProfileComponent } from '@shared/components';
import { MenuItem } from '../menu-item.interface';
import { MenuService } from '../side-menu.service';

@Component({
  selector: 'app-side-nav',
  imports: [CommonModule, RouterModule, FontAwesomeModule, ProfileComponent], // FontAwesomeModule, CommonModule, ProfileComponent
  templateUrl: './side-nav.component.html',
})
export class SideNavComponent {
  private menuService = inject(MenuService);
  private roleService = inject(RoleApiService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  private role = this.authService.currentUser()?.roleId;
  private menuItems: MenuItem[] = [
    { path: 'home', label: 'Inicio', icon: faHouse },
    { path: 'operation', label: 'Gestion de Operaciones', icon: faMoneyBillTransfer },
    { path: 'request', label: 'Gestion de solicitudes', icon: faMoneyBillTransfer },
    { path: 'applications', label: 'Gestion de Solicitudes', icon: faTable },
    { path: 'reports', label: 'Reportes', icon: faChartPie },
    { path: 'simulator', label: 'Simulador', icon: faCalculator },
    { path: 'config', label: 'Configuración', icon: faGear },

  ];

  activeRoute = '';
  filteredMenuItems = computed(() => {
    const allowedRoutes = this.role ? this.roleService.getRolePermissions()()[this.role] || [] : [];

    return this.menuItems
      .filter(item => allowedRoutes.some(route => route.path.startsWith(item.path)));
  });

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects;
      }
    });
  }

  navigate(path: string) {
    this.router.navigate([path], { relativeTo: this.route }).then(() => {
      if (this.menuService.menuOpen()) {
        this.menuService.toggleMenu();
      }
    });
  }

  isActive(route: string): boolean {
    return this.activeRoute.includes(route);
  }
}
